import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Avatar, Badge, Box, ProgressCircle, Flex, Heading, Spinner, Stack, VStack, Wrap, Presence } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoInvestorProfile, ScoSignupRequest } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
export const SignupRequestPreviewInvestorMatches = props => {
  const $ = _c(19);
  const {
    getBreakpointValue,
    isMobile
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($selectedInvestorTagTitles: [String]) {
        scoInvestorSearchDraft(
          selectedInvestorTagTitles: $selectedInvestorTagTitles
          matchedInvestorProfilesLimit: 100
        ) {
          id
          relevantInvestorTags
          matchedInvestorProfiles {
            id
            title
            logoUrl
            primaryInvestorType
            hqLocationCountry
            investorTags {
              id
              title
            }
          }
          matchedInvestorProfilesCount
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.signupRequest?.investorIndustryTagTitles;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ssr: false,
      variables: {
        selectedInvestorTagTitles: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const draftQuery = useQuery(t0, t2);
  let t3;
  if ($[3] !== draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfiles || $[4] !== draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfilesCount || $[5] !== getBreakpointValue || $[6] !== isMobile) {
    const matchedInvestors = draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfiles || [];
    let t4;
    if ($[8] !== getBreakpointValue) {
      t4 = getBreakpointValue([3, 3, 4]);
      $[8] = getBreakpointValue;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== getBreakpointValue) {
      t5 = getBreakpointValue([4, 4, 6, 6, 6]);
      $[10] = getBreakpointValue;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    const t6 = isMobile ? "sm" : "lg";
    let t7;
    if ($[12] !== draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfilesCount) {
      t7 = draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfilesCount ? draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfilesCount?.toLocaleString() : <Spinner />;
      $[12] = draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfilesCount;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t7) {
      t8 = <Badge bgColor="purple.300" borderRadius="lg" color="black" fontSize="0.9em" fontWeight="inherit" marginX={2} padding="0.75" size="md">{t7}</Badge>;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t6 || $[17] !== t8) {
      t9 = <Heading size={t6} textAlign="center">{" We have"}{t8}potential investors for you.</Heading>;
      $[16] = t6;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    t3 = <VStack align="center" background="colorPalette.container" borderRadius="xl" boxShadow="md" gap={t4} justify="center" padding={t5} width="full">{t9}<Wrap gap="0" justify="center" size="lg" spaceX="-1">{matchedInvestors.slice(0, 14).map(_temp)}</Wrap>{!isMobile && <VStack align="center" gap={2} justify="center" width="full">{matchedInvestors.slice(0, 3).map(_temp2)}</VStack>}</VStack>;
    $[3] = draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfiles;
    $[4] = draftQuery.data?.scoInvestorSearchDraft?.matchedInvestorProfilesCount;
    $[5] = getBreakpointValue;
    $[6] = isMobile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const MatchCard = props => {
  const $ = _c(25);
  let t0;
  if ($[0] !== props.investor.title) {
    t0 = <Avatar.Fallback borderRadius="md" name={props.investor.title} />;
    $[0] = props.investor.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.investor.logoUrl) {
    t1 = <Avatar.Image borderRadius="md" src={props.investor.logoUrl} />;
    $[2] = props.investor.logoUrl;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <Avatar.Root bgColor="colorPalette.fg" borderRadius="md" filter="blur(4px)" size="lg">{t0}{t1}</Avatar.Root>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.investor.title) {
    t3 = <Heading filter="blur(4px)" size="md">{props.investor.title}</Heading>;
    $[7] = props.investor.title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props.investor.investorTags) {
    t4 = props.investor.investorTags.slice(0, 3).map(_temp3);
    $[9] = props.investor.investorTags;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <Wrap align="center" direction="row" gap={1} justify="start">{t4}</Wrap>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <VStack align="start" gap={2} justify="start" width="full">{t3}{t5}{" "}</VStack>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <Stack align="center" direction="row" gap={4} justify="center" padding={4} width="full">{t2}{t6}</Stack>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ProgressCircle.Circle><ProgressCircle.Track stroke="colorPalette.bg" /><ProgressCircle.Range stroke="colorPalette.500" /></ProgressCircle.Circle>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props.matchScore) {
    t9 = <Flex align="center" alignSelf="stretch" bgColor="sidebarBackground" justify="center" padding={2}><ProgressCircle.Root value={props.matchScore}>{t8}</ProgressCircle.Root></Flex>;
    $[20] = props.matchScore;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t9) {
    t10 = <Stack align="center" background="PurpleSlate" borderRadius="lg" boxShadow="lg" direction="row" gap={0} justify="start" overflow="hidden" padding={0} width="full">{t7}{t9}</Stack>;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
function _temp(investor, i) {
  return <Presence key={i} animationDuration="moderate" present={true} style={{
    animationDelay: `${i / 10}s`
  }} animationName={{
    _open: "slide-from-bottom, fade-in",
    _closed: "slide-to-bottom, fade-out"
  }}><Avatar.Root border="1px solid white" size="sm"><Avatar.Fallback name={investor.title} /><Avatar.Image src={investor.logoUrl} /></Avatar.Root></Presence>;
}
function _temp2(investor_0, i_0) {
  return <Box key={i_0} width="full"><Presence animationDuration="moderate" present={true} style={{
      animationDelay: `${i_0 / 10}s`
    }} animationName={{
      _open: "slide-from-bottom, fade-in",
      _closed: "slide-to-bottom, fade-out"
    }}><MatchCard key={i_0} investor={investor_0} matchScore={100 - i_0 * 3} /></Presence></Box>;
}
function _temp3(tag, i) {
  return <Badge key={i} backgroundColor="blackAlpha.600" border="none" borderRadius="sm" boxShadow="none" color="colorPalette.border" fontSize="10px" fontWeight="600" letterSpacing="0.05em" lineHeight="1" overflow="hidden" padding={1} textAlign="center" textOverflow="ellipsis" textTransform="uppercase" variant="subtle" whiteSpace="nowrap">{tag.title}</Badge>;
}